export const factorName = {
  markFactors: 'Mean',
  bidFactors: 'Bid',
  askFactors: 'Ask',
} as const;

export const factors = Object.keys(factorName) as Array<keyof typeof factorName>;
